import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  SimpleChanges,
} from "@angular/core";
import { NotifierService } from "src/app/_services/notifier.service";
import { Subscription, Subject } from "rxjs";
import { take, debounceTime } from "rxjs/operators";
import * as Models from "../../charges/chargesbyservice/service-charges.model";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { ServiceService } from "../../charges/chargesbyservice/chargeser.service";
import { MonthlyExpandService } from "../../charges/monthlybilling.service";
import { Output } from "@angular/core";
import { EventEmitter } from "@angular/core";

@Component({
  selector: "app-all-charges-by-service",
  templateUrl: "./chargesbyservice.component.html",
  styleUrls: ["./chargesbyservice.component.css"],
})
export class AllChargesByServiceComponent implements OnInit {
  //   @ViewChild(FilterByTagsComponent) filterComponent!: FilterByTagsComponent;
  @Input() monthYear: any;
  @Input() accountId: any;
  @Input() regionId: any;
  @Input() isExpandedAll: any;
  @Output() initialized = new EventEmitter<void>();
  market_isExpandedAll: any;
  @Output() monthlyData = new EventEmitter<{
    services: any[];
    prevMonth: any[];
    total: number;
    totser: number;
  }>();
  @Input() filteredTag: any;
  market_filteredTag: any;
  @Input() searchTerm: any;
  market_searchTerm: any;
  accountOptions: { id: number; name: string }[] = [];

  selectedAccountIds: any = [];

  breakpoints = {
    region: false,
    product_family: false,
    line_item: false,
  };

  graph_curr: any = [];
  graph_prev: any = [];
  market_prevMonth: any = [];

  gear: boolean = false;
  currentPage = 1;
  market_currentPage = 1;
  pageSizeOptions = [20, 50, 100];

  filterTags = false;

  headers: Models.Header[] = [
    { key: "product_code", label: "Service Name", sortable: true },
    { key: "usage", label: "Usage", sortable: false },
    { key: "base_cost", label: "Public Cost (USD)", sortable: true },
    { key: "final_cost", label: "Final Cost (USD)", sortable: true },
  ];
  prevMonth: any = [];
  services: Models.Service[] = [];
  sortKey: Models.SortableColumn = "product_code";
  // searchTerm = "";
  filter = "";
  sortDirection: "asc" | "desc" = "asc";
  total: any;
  totactiveser: any = 0;
  filteredList: Models.Service[] = [];
  funRef: any = {};
  currentMessage!: Subscription;
  // filteredTag: { accountId: string; tagKey: string; tagValue: string } | null =
  //   null;
  selectedPageSize = 20;
  market_selectedPageSize = 20;
  usagePagination = false;
  market_preferencesData: "No";
  preferencesData: {
    pageSize: number;
    wrapLines: boolean;
    usagePagination: boolean;
    visibleColumns: {
      description: boolean;
      usageQuantity: boolean;
      amountUsd: boolean;
    };
    breakpoints: {
      region: boolean;
      product_family: boolean;
      line_item: boolean;
    };
    selectedAccountIds: string[];
  } = {
    pageSize: 20,
    wrapLines: false,
    usagePagination: true,
    visibleColumns: {
      description: true,
      usageQuantity: true,
      amountUsd: true,
    },
    breakpoints: {
      region: false,
      product_family: false,
      line_item: false,
    },
    selectedAccountIds: [],
  };
  chartInstance: any;
  selectedView: any = "monthly";
  market_total: any;
  market_totactiveser: any;
  market_services: any;
  market_filteredList: any[];
  activeBreakpoints: any;

  constructor(
    public notifier: NotifierService,
    private router: Router,
    private route: ActivatedRoute,
    private service: ServiceService,
    private monthexp: MonthlyExpandService
  ) {}

  ngOnInit(): void {
    this.initialized.emit();
    this.preferencesData.selectedAccountIds.push(this.accountId);
    this.funRef = {};

    const navigation = this.router.getCurrentNavigation();
    if (!navigation?.extras?.state) {
      this.route.queryParams.pipe(take(1)).subscribe((p): void => {
        const { open, _t, ...fp } = p;
        const b =
          p["breakup"]
            ?.toString()
            .split(",")
            .map((x: any) => x.trim())
            .filter(Boolean) || [];
        const allKeys: (keyof typeof this.preferencesData.breakpoints)[] = [
          "region",
          "product_family",
          "line_item",
        ];

        if (p["tag_key"] && p["tag_value"] && b.length) {
          // set breakpoints
          this.preferencesData.breakpoints = {
            ...this.preferencesData.breakpoints,
            ...b.reduce((acc: any, k: string) => ((acc[k] = true), acc), {}),
          };
          this.filteredTag = {
            accountId: p["account_ids"] || this.accountId,
            tagKey: p["tag_key"],
            tagValue: p["tag_value"],
          };
          this.market_filteredTag = {
            accountId: p["account_ids"] || this.accountId,
            tagKey: p["tag_key"],
            tagValue: p["tag_value"],
          };
          this.loadPreferences(fp);
          return;
        }

        if ("mode" in p) {
          allKeys.forEach(
            (k) => (this.preferencesData.breakpoints[k] = b.includes(k))
          );
          this.loadPreferences(fp);
          return;
        }

        if (!("open" in p)) {
          this.load();
          return;
        }

        setTimeout(
          () => this.loadPreferences({ ...fp, account_ids: this.accountId }),
          100
        );
      });
    } else {
      this.load();
    }
  }

  toggleExpandAll() {
    this.monthexp.toggleExpandRecursive(this.services, !this.isExpandedAll);
    this.isExpandedAll = !this.isExpandedAll;
    this.services.forEach(
      (s) => (this.productNameExpandedMap[s.product_code] = this.isExpandedAll)
    );
  }

  market_toggleExpandAll() {
    const newState = !this.market_isExpandedAll;
    this.monthexp.toggleExpandRecursive(this.market_services, newState);

    this.market_services.forEach((s: any) => {
      this.productNameExpandedMap[s.product_code] = newState;
    });

    this.market_isExpandedAll = newState;
  }

  ngOnChanges(changes: SimpleChanges): void {
    const changedLater = (key: "monthYear" | "accountId"): boolean =>
      !!changes[key] && !changes[key].isFirstChange();

    this.preferencesData = this.getDefaultPreferences();

    if (changes["filteredTag"] && this.filteredTag) {
      this.onTagsFiltered(this.filteredTag);
    }

    if (changedLater("monthYear") || changedLater("accountId")) {
      this.filteredTag = null;
      this.load(); // call API only when monthYear or accountId changes
    }

    if (changes["searchTerm"] || changes["tableData"]) {
      this.onSearch();
    }

    if (changes["isExpandedAll"] && !changes["isExpandedAll"].isFirstChange()) {
      // this.monthexp.toggleExpandRecursive(this.services, this.isExpandedAll);
      // Expand all
      if (this.isExpandedAll) {
        this.monthexp.toggleExpandRecursive(this.services, true);
      } else {
        this.monthexp.toggleExpandRecursive(this.services, false);
      }

      // Collapse all
    }
  }

  handlePageSizeChange(newPageSize: number): void {
    this.selectedPageSize = newPageSize;
    this.market_selectedPageSize = newPageSize;
    this.currentPage = 1; // reset page
    this.market_currentPage = 1;
  }

  private async fetchAndBind(
    query: Record<string, any>,
    pushToUrl = true
  ): Promise<void> {
    this.notifier.loading(true);

    try {
      // Decide query based on selected view
      const apiQuery = {
        ...query,
        type: 'charge_by_service', // 'daily', 'weekly', or 'monthly'
      };

      await this.loadViewData(apiQuery, pushToUrl);
    } catch (err) {
      // fallback if API fails
      this.total = this.totactiveser = 0;
      this.services = this.filteredList = [];
      this.market_services = this.market_filteredList = [];
      this.prevMonth = [];
    } finally {
      this.notifier.loading(false);
    }
  }

  onSubmitClick(): void {
  // Copy current checkbox selections into preferencesData
  this.preferencesData.breakpoints = { ...this.breakpoints };
  // Then call load, which will include breakpoints in params
  this.load();
}

clearPreferences(): void {
  this.breakpoints = {
    region: false,
    product_family: false,
    line_item: false,
  };
  this.preferencesData.breakpoints = { ...this.breakpoints };
  // Reload data without breakpoints
  this.load();
}

private async loadViewData(
  query: Record<string, any>,
  pushToUrl = true
): Promise<void> {
  try {
    const { result, fullQuery } = await this.service.loadData(query);
    // ✅ Extract AWS and Marketplace arrays correctly
    const awsServices =
      result?.response?.calculated_all_account_services?.aws ?? [];
    const marketServices =
      result?.response?.calculated_all_account_services?.marketplace ?? [];

    // ✅ Compute totals
    this.total = awsServices.reduce(
      (sum: number, s: any) => sum + (Number(s.final_cost) || 0),
      0
    );
    this.totactiveser = awsServices.length;

    this.market_total = marketServices.reduce(
      (sum: number, s: any) => sum + (Number(s.final_cost) || 0),
      0
    );
    this.market_totactiveser = marketServices.length;
    this.services = awsServices.map((s: any, idx: number) => ({
      ...s,
      expanded: false,
      _index: idx,
    }));

    this.filteredList = [...this.services];

    this.market_services = marketServices.map((s: any, idx: number) => ({
      ...s,
      expanded: false,
      _index: idx,
    }));

    this.market_filteredList = [...this.market_services];

    // ✅ Handle URL params if needed
    if (pushToUrl && fullQuery) {
      const params: any = {};
      fullQuery.split('&').forEach((pair: string) => {
        const [key, value] = pair.split('=');
        if (key && value !== undefined) params[key] = value;
      });
      params['_t'] = Date.now();

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: params,
        replaceUrl: true,
      });
    } 

    // ✅ Build Graph data (AWS + Marketplace combined)
    this.graph_curr = [
      ...this.services,
      { product_code: 'AWS marketplace', final_cost: this.market_total },
    ];
  } catch (error) {
    console.error('❌ Error in loadViewData:', error);
  }
}

  private baseParams(accountIds: string | string[]): Record<string, any> {
    const [month, year] = this.monthYear.split("-");
    return { account_ids: accountIds, year, month };
  }

  async loadPreferences(filteredQuery: any): Promise<void> {
    this.filteredTag =
      filteredQuery?.tag_key && filteredQuery?.tag_value
        ? {
            accountId: filteredQuery.account_ids,
            tagKey: filteredQuery.tag_key,
            tagValue: filteredQuery.tag_value,
          }
        : null;
    const { mode, ...queryWithoutMode } = filteredQuery;

    await this.fetchAndBind(queryWithoutMode);

    if (mode) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { mode },
        queryParamsHandling: "merge",
        replaceUrl: true,
      });
    }
    this.searchSubscription = this.searchSubject
      .pipe(debounceTime(300))
      .subscribe((term) => this.applyFilter(term));
    this.filteredList = [...this.services];

    this.marketSearchSubscription = this.marketSearchSubject
      .pipe(debounceTime(300))
      .subscribe((term) => this.applyMarketFilter(term));
    this.market_filteredList = [...this.market_services];
  }
async load(): Promise<void> {
  this.notifier.loading(true);

  // 🔹 Load all stored account IDs and names
  const { options, ids: accountIds } = this.loadAccountsFromStorage();
  this.accountOptions = options;

  const [month, year] = this.monthYear.split("-");

  // 🔹 Base params
  const params: Record<string, any> = {
    account_ids: accountIds.join(","), // ✅ all accounts
    year,
    month,
    type: "charge_by_service",
  };

  // ✅ Type-safe active breakpoint detection
  const keys = Object.keys(this.breakpoints) as Array<
    keyof typeof this.breakpoints
  >;
  const activeBreakpoints = keys.filter((key) => this.breakpoints[key]);

  if (activeBreakpoints.length > 0) {
    params["breakup"] = activeBreakpoints.join(","); // e.g. breakup=region,product_family
  }

  console.log("📦 Final Params for API:", params);

  try {
    await this.loadViewData(params);
  } catch (error) {
    console.error("❌ load() failed:", error);
  } finally {
    setTimeout(() => {
      this.notifier.loading(false);
    }, 1000);
  }
}

private loadAccountsFromStorage(): {
  options: { id: number; name: string }[];
  ids: string[];
} {
  const stored = localStorage.getItem("accountIdData");
  let options: { id: number; name: string }[] = [];
  let ids: string[] = [];

  if (stored) {
    try {
      const parsed = JSON.parse(stored);
      const list = parsed.list || [];
      options = list.map((item: any) => ({
        id: item.accountId,
        name: `${item.accountName} (${item.accountId})`,
      }));
      ids = list.map((item: any) => item.accountId);
    } catch (err) {
      console.error("Error parsing accountIdData from localStorage", err);
    }
  }

  return { options, ids };
}


  // market_onSearch() {
  //   this.marketSearchSubject.next(this.market_searchTerm);
  // }

  market_onSearch(): void {
  const term = String(this.market_searchTerm ?? "").trim().toLowerCase();

  if (!term) {
    this.market_filteredList = [...this.market_services];
  } else {
    this.market_filteredList = this.market_services.filter(
      (service: any) =>
        (service.product_code || "").toLowerCase().includes(term) ||
        (service.product_name || "").toLowerCase().includes(term)
    );
  }

  this.market_currentPage = 1; // reset pagination
}

  handlePreferencesResponse(data: any) {
    this.gear = false;
    this.isExpandedAll = false;
    if (data.preferences) {
      this.preferencesData = data.preferences;
      this.usagePagination = data.preferences.usagePagination;
      this.breakpoints = data.preferences.breakpoints;
      this.selectedAccountIds = data.preferences.selectedAccountIds;
    } 
    if (data.services) {
      this.services = data.services;
      this.monthexp.addExpandedFlag(data.services || []);
      this.filteredList = [...this.services];
      this.market_filteredList = [...this.market_services];
    } else {
      this.activeBreakpoints = Object.keys(
        data.preferences?.breakpoints ?? {}
      ).filter((key) => data.preferences.breakpoints[key]);

      if (data.preferences?.breakpointsChanged) {
        let params: Record<string, any> = {
          ...this.baseParams(this.accountId),
        };

        if (this.activeBreakpoints.length > 0) {
          params = {
            ...params,
            mode: "preferences",
            breakup: this.activeBreakpoints,
          };
        } else {
          const { mode, breakup, ...rest } = params;
          params = rest;
        }

        this.fetchAndBind(params);
      } 
    }

    if (data.current_month) {
      this.total = data.current_month[0].final_cost;
    } 

    if (this.filteredTag) {
      this.load();
    } 

    this.currentPage = 1;
    this.market_currentPage = 1;
  }

  async onTagsFiltered({
    accountId,
    tagKey,
    tagValue,
  }: {
    accountId: any;
    tagKey: string;
    tagValue: string;
  }): Promise<void> {
    this.isExpandedAll = false;
    this.filteredTag = { accountId, tagKey, tagValue };
    this.preferencesData = this.getDefaultPreferences(accountId);

    const params = {
      ...this.baseParams(accountId),
      tag_key: tagKey,
      tag_value: tagValue,
      mode: "filter",
    };
    await this.fetchAndBind(params);
  }

  get paginatedList() {
    return this.monthexp.paginate(
      this.filteredList,
      this.currentPage,
      this.selectedPageSize
    );
  }

  get totalPages() {
    return this.monthexp.totalPages(this.filteredList, this.selectedPageSize);
  }

  goToNextPage() {
    this.currentPage = this.monthexp.nextPage(
      this.currentPage,
      this.totalPages
    );
  }

  goToPreviousPage() {
    this.currentPage = this.monthexp.prevPage(this.currentPage);
  }

  get marketPaginatedList() {
    return this.monthexp.paginate(
      this.market_filteredList,
      this.market_currentPage,
      this.market_selectedPageSize
    );
  }

  get marketTotalPages() {
    return this.monthexp.totalPages(
      this.market_filteredList,
      this.market_selectedPageSize
    );
  }

  marketNext() {
    this.market_currentPage = this.monthexp.nextPage(
      this.market_currentPage,
      this.marketTotalPages
    );
  }

  marketPrev() {
    this.market_currentPage = this.monthexp.prevPage(this.market_currentPage);
  }

  clearTagFilter() {
    this.filteredTag = null;
    this.preferencesData = this.getDefaultPreferences();
    this.load();
  }

  toggle(item: any) {
    item.expanded = !item.expanded;
  }

  searchSubject: Subject<string> = new Subject<string>();
  searchSubscription!: Subscription;

  marketSearchSubject: Subject<string> = new Subject<string>();
  marketSearchSubscription!: Subscription;

  // onSearch() {
  //   this.searchSubject.next(this.searchTerm);
  // }

onSearch(): void {
  const term = String(this.searchTerm ?? "").trim().toLowerCase();

  if (!term) {
    this.filteredList = [...this.services];
  } else {
    this.filteredList = this.services.filter(
      (service) =>
        (service.product_code || "").toLowerCase().includes(term) ||
        (service.product_name || "").toLowerCase().includes(term)
    );
  }

  this.currentPage = 1; // reset pagination
}


  applyFilter(searchText: string) {
    const filterText = searchText.trim().toLowerCase();

    if (!filterText) {
      this.filteredList = [...this.services];
      return;
    }

    this.filteredList = this.services.filter(
      (service) =>
        (service.product_code || "").toLowerCase().includes(filterText) ||
        (service.product_name || "").toLowerCase().includes(filterText)
    );
  }

  applyMarketFilter(searchText: string) {
    const filterText = searchText.trim().toLowerCase();

    if (!filterText) {
      this.market_filteredList = [...this.market_services];
      return;
    }

    this.market_filteredList = this.market_services.filter(
      (service: any) =>
        (service.product_name || "").toLowerCase().includes(filterText) ||
        (service.product_code || "").toLowerCase().includes(filterText) ||
        (service.region || "").toLowerCase().includes(filterText)
    );
  }

  // Track which product_name rows are expanded
  productNameExpandedMap: { [key: string]: boolean } = {};

  toggleProductName(product: Models.Service) {
    const isNowExpanded = !this.productNameExpandedMap[product.product_code];
    this.productNameExpandedMap[product.product_code] = isNowExpanded;

    if (!isNowExpanded) {
      product.expanded = false;
    }
  }

  // Helper function to check expanded state
  isProductNameExpanded(service: Models.Service): boolean {
    return !!this.productNameExpandedMap[service.product_code];
  }

  trackByProductCode(index: number, item: Models.Service): string {
    return item.product_code;
  }

  private getDefaultPreferences(accountIds: any[] = []): any {
    return {
      pageSize: 20,
      wrapLines: false,
      usagePagination: true,
      visibleColumns: {
        description: true,
        usageQuantity: true,
        amountUsd: true,
      },
      breakpoints: {
        region: false,
        product_family: false,
        line_item: false,
      },
      selectedAccountIds: accountIds,
    };
  }

  onViewChange() {
    this.load();
  }
}